import React, { useEffect, useMemo, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import * as APIModels from "../../../models";
import { MatterService } from "../../../services/ClientService";
import { DeleteSharp, ExpandMore } from "@material-ui/icons";
import {
    Button,
    Stack,
    Checkbox,
    Card,
    Accordion,
    AccordionDetails,
    AccordionSummary,
    TextField,
} from "@mui/material";
import AppBar from "../AppBar";

import { Globals } from "../../../helpers/globals";
import qs from "qs";
import Grid from "@mui/system/Unstable_Grid";

interface QueryParams {
    copyFrom?: string;
}

export default function CreateMatterManagmentPage() {
    const [organizationId, _] = useState(
        Globals.currentUserValue.organizationID
    );
    const [keyChecked, setKeyChecked] = useState<number>(0);
    const [matterNumber, setMatterNumber] = useState("");
    const [storedTable, setStoredTable] = useState<Array<string>>();
    const [expanded, setExpanded] = useState<boolean>(true);
    const [mergefields, setMergefields] = useState<
        {
            key: number;
            identifier: string;
            value: string;
        }[]
    >([
        {
            key: 0,
            identifier: "Populating",
            value: "Please wait",
        },
    ]);
    const location = useLocation();

    const isChecked = (key: number): boolean => {
        return keyChecked === key;
    };

    useEffect(() => {
        const query = qs.parse(location.search, {
            ignoreQueryPrefix: true,
        }) as QueryParams;

        if (query.copyFrom) {
            MatterService.copyFrom({ matterId: query.copyFrom }).then((res) => {
                if (res.data && res.successful) {
                    console.log({ ...res.data });
                    const keys = Object.keys(
                        res.data.mergeFields ?? ["ERROR"]
                    ).filter((A) => A !== "");
                    const identifierIndex = keys.findIndex((value: string) => {
                        return (
                            value ===
                            res.data?.identifier?.matterMapping?.fieldKey
                        );
                    });

                    setMatterNumber(res.data.matterNumber ?? "ERROR");
                    setStoredTable(keys);
                    setKeyChecked(identifierIndex);
                } else {
                    console.error(res.errorMessage);
                }
            });
        } else {
            MatterService.nextMatterV2({
                organizationId: organizationId ?? APIModels.EmptyGuid,
            })
                .then((res) => {
                    if (res.data && res.successful) {
                        console.log(res.data);
                        setMatterNumber(res.data);
                    } else {
                        console.error(res.errorMessage);
                    }
                })
                .then(() => {
                    MatterService.getCols({
                        organizationId: organizationId ?? APIModels.EmptyGuid,
                    })
                        .then((res) => {
                            if (res.data && res.successful) {
                                setStoredTable(res.data);
                            } else {
                                console.error(res.errorMessage);
                            }
                        })
                        .catch((err) => console.error(err));
                });
        }
    }, [organizationId]);

    useEffect(() => {
        const fields =
            storedTable &&
            storedTable.map((storedTableIdentifier, key) => {
                return {
                    key: key,
                    identifier: storedTableIdentifier,
                    value: "",
                };
            });
        if (fields) {
            setMergefields(fields);
        }
    }, [storedTable]);

    const addNewMatter = () => {
        const kv = {} as { [key: number]: { [key: string]: string } };
        let matterIdentifier = "";
        mergefields.forEach(({ key, identifier, value }) => {
            if (value !== "" || value !== undefined || value !== null) {
                kv[key] = { [identifier]: value };
            }
            if (key === keyChecked && key !== 0) {
                const temp = kv[0];
                kv[0] = { [identifier]: value };
                kv[key] = temp;
                matterIdentifier = identifier;
            }
        });

        console.log({ keyValueParings: { ...kv } });

        MatterService.addV2({
            organizationId: organizationId ?? APIModels.EmptyGuid,
            body: {
                dynamoDbEntry: kv,
                identifier: matterIdentifier,
            },
        }).then((res) => {
            if (res.successful && res.data) {
                window.location.href = "/matter/management";
            } else {
                setMatterNumber(res.data ?? "");
                console.error(res.errorMessage ?? "unknown error");
            }
        });
    };

    const handleRemoveRow = (index: number) => {
        const updatedMergefields = [...mergefields];
        updatedMergefields.splice(index, 1);
        setMergefields(updatedMergefields);
    };

    const handleEditIdent = (index: number, value: string) => {
        const updatedMergefields = [...mergefields];
        const editIndex = updatedMergefields.findIndex((mf) => mf.key == index);
        if (editIndex !== -1) {
            updatedMergefields[editIndex].identifier = value;
        }

        setMergefields(updatedMergefields);
    };

    const handleEditValue = (index: number, value: string) => {
        const updatedMergefields = [...mergefields];
        const editIndex = updatedMergefields.findIndex((mf) => mf.key == index);
        if (editIndex !== -1) {
            updatedMergefields[editIndex].value = value;
        }

        setMergefields(updatedMergefields);
    };

    const handleAddRow = () => {
        const updatedMergefields: {
            key: number;
            identifier: string;
            value: string;
        }[] = [...mergefields];

        const newMergeField = {
            key: updatedMergefields.length,
            identifier: "",
            value: "",
        };
        updatedMergefields.push(newMergeField);
        setMergefields(updatedMergefields);
    };

    const handleValidateKey = (input: string) => {
        // Check if the input contains only alphanumeric characters and underscores
        const regex = /^[a-zA-Z0-9_]+$/;
        return regex.test(input);
    };

    // Update the onChange event handler for the identifier input field
    const handleKeyOnChange = (
        e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
        k: {
            key: number;
            identifier: string;
            value: string;
        }
    ) => {
        const inputValue = e.currentTarget.value;
        const isValid = handleValidateKey(inputValue);

        // If the input is valid, proceed with editing the mergefield identifier
        if (isValid || inputValue === undefined || inputValue === "") {
            handleEditIdent(k.key, inputValue);
        } else {
            // If the input is invalid, display an error message or prevent form submission
            alert(
                "Invalid input: only alphanumeric characters and underscores are allowed"
            );
        }
    };

    return (
        <div className="content">
            <div className="container-fluid">
                <Stack direction="column" spacing={4} marginTop={4}>
                    <AppBar
                        sx={{ width: "100%", paddingY: 1, paddingX: 2 }}
                        buttonSpacing={6}
                        iconSpacing={6}
                    />
                    <Card>
                        <Accordion
                            sx={{ padding: "4px", transitionDuration: "300ms" }}
                            expanded={expanded}
                        >
                            <AccordionSummary
                                expandIcon={<ExpandMore />}
                                aria-controls="panel1-content"
                                id="panel1-header"
                                sx={{ padding: "-1px" }}
                                onClick={() => {
                                    setExpanded(!expanded);
                                }}
                            >
                                <h5>
                                    Merge Fields for Matter #: {matterNumber}
                                </h5>
                            </AccordionSummary>
                            <Grid
                                container
                                spacing={2}
                                width="100%"
                                paddingLeft={4}
                            >
                                <Grid xs={2}>Identifier </Grid>
                                <Grid xs={2}>Mergefield Key </Grid>
                                <Grid xs={4}>Mergefield Value </Grid>
                                <Grid xs={2} justifyContent="end">
                                    {" "}
                                    Delete Row{" "}
                                </Grid>
                            </Grid>
                            <AccordionDetails>
                                {mergefields.map((k, _) => {
                                    return (
                                        <Grid
                                            container
                                            spacing={2}
                                            width="100%"
                                        >
                                            <Grid xs={2}>
                                                <Checkbox
                                                    checked={isChecked(k.key)}
                                                    onChange={() =>
                                                        setKeyChecked(k.key)
                                                    }
                                                />
                                            </Grid>
                                            <Grid xs={4}>
                                                <TextField
                                                    type="text"
                                                    value={k.identifier}
                                                    variant="standard"
                                                    onChange={(e) =>
                                                        handleKeyOnChange(e, k)
                                                    }
                                                    fullWidth
                                                />
                                            </Grid>
                                            <Grid xs={4}>
                                                <TextField
                                                    type="text"
                                                    value={k.value}
                                                    variant="standard"
                                                    onChange={(e) =>
                                                        handleEditValue(
                                                            k.key,
                                                            e.target.value
                                                        )
                                                    }
                                                    fullWidth
                                                />
                                            </Grid>
                                            <Grid xs={2} justifyContent="end">
                                                <Button
                                                    onClick={() =>
                                                        handleRemoveRow(k.key)
                                                    }
                                                    color="error"
                                                >
                                                    <DeleteSharp color="error" />
                                                    Delete Row
                                                </Button>
                                            </Grid>
                                        </Grid>
                                    );
                                })}
                            </AccordionDetails>
                        </Accordion>
                    </Card>
                    <Card sx={{ width: "100%", paddingY: 1, paddingX: 2 }}>
                        <Stack
                            direction="row"
                            sx={{
                                justifyContent: "space-between",
                            }}
                        >
                            <Stack
                                direction="row"
                                spacing="2rem"
                                sx={{
                                    justifyContent: "left",
                                }}
                            >
                                <button
                                    className="btn btn-primary mr-3"
                                    onClick={handleAddRow}
                                >
                                    <Stack direction="row" spacing={2}>
                                        <b>Add Row</b>
                                    </Stack>
                                </button>
                                <button
                                    className="btn btn-success mr-3"
                                    onClick={addNewMatter}
                                >
                                    <Stack direction="row" spacing={2}>
                                        <b>Save Matter</b>
                                    </Stack>
                                </button>
                            </Stack>
                            <button
                                className="btn btn-danger mr-3"
                                onClick={() =>
                                    (window.location.href =
                                        "/matter/management")
                                }
                            >
                                <Stack direction="row" spacing={2}>
                                    <b>Cancel Creation</b>
                                </Stack>
                            </button>
                        </Stack>
                    </Card>
                </Stack>
            </div>
        </div>
    );
}
